<div class="custom-dialog-header d-flex justify-content-between p-3">
    <div class="custom-dialog-header-txt">{{ 'GROUP.EDIT_GROUP' | translate}}</div>
    <div class="custom-dialog-close-container">
      <button type="button" class="custom-dialog-close-btn" (click)="close()">
        <span class="pi pi-times"></span>
      </button>
    </div>
  </div>
  <div class="panel_wrapper">
    <div class="pb-4">
        <input class="input_field w-100" maxlength="4" [(ngModel)]="tableName">
    </div>
    <div class="text-end">
      <button class="create_btn w_45" (click)="editGroup()">{{ 'SAVE' | translate}}</button>
    </div>
  </div>
  